import Component from '../core/Component'
import Scroll from '../services/Scroll'
import { toggleClass } from '../utils/dom'

const STATES = {
    SPACER: 'has-spacer'
}

export default class TagList extends Component { // Udělat opačně, první spacery načíst v html a pak je smazat v js

    constructor(element) {
        super(element)

        this.ref = {
            items: []
        }

        this.currentSpacers = []
        this.timer = null
    }

    prepare() {
        Scroll.on('resize', this.handleResize)
        this.handleResize()

        this.items = this.ref.items.map(element => Component.getFromElement(element))
        this.items.forEach(item => {
            item.on({
                enter: this.handleItemEnter,
                leave: this.handleItemLeave
            })
        })
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
    }

    handleItemEnter = event => {
        clearTimeout(this.timer)
        this.element.classList.add('is-active')
    }

    handleItemLeave = event => {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => this.element.classList.remove('is-active'), 100)
    }

    handleResize = () => {
        var spacerWidth = this.element.querySelector('[data-spacer]').scrollWidth
        var containerWidth = this.element.scrollWidth
        var currWidth = 0
        var currTop = this.ref.items[0].getBoundingClientRect().top

        this.ref.items.map((element, index) => {
            if (element.classList.contains(STATES.SPACER)) {
                element.classList.remove(STATES.SPACER)
            }

            let elRect = element.getBoundingClientRect()
            let elTop = elRect.top
            let elWidth = elRect.width
            let isFirst = false

            if (this.ref.items[index-1]) {
                let prevElTop = this.ref.items[index-1].getBoundingClientRect().top
                isFirst = (prevElTop != elTop) ? true : false
            } else {
                isFirst = true
            }

            if (currTop != elTop) {
                currWidth = 0
                currTop = elTop
            }

            let finalWidth = currWidth + elWidth

            if (finalWidth < containerWidth && !isFirst) {
                element.classList.add(STATES.SPACER)
            }

            currWidth += element.scrollWidth
        })
    }
}